// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "COMING_SOON" || $$enum === "ACTIVE" || $$enum === "OFF_MLS") {
    return $$enum;
  }
  
}

function mlsListingTypeV5_fromString(str) {
  return mlsListingTypeV5_decode(str);
}

var Utils = {
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalDraftProperty",
          "kind": "LinkedField",
          "name": "draftProperty",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mlsListingType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraft",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
